  <footer  id="footeri">
    <div class="row">
      <div class="col-sm-12" id="first" style="border-right: 2px solid  white; margin-bottom: 50px;">
      <div class="footer-top">
        <div class="container">
          <!-- <div class="row"> -->
            <div class="col-lg-3 col-md-6 footer-contact" style=" margin: 0 auto; text-align: center">
              <!-- <h3>Resi.</h3> -->
              <img
                src="../../assets/img/doktorslogowhite.png"
                style="width:150px;z-index:999;padding-bottom: 10px;"
              />
            </div>
            <div
              class=" footer-newsletter"
              style="text-align:center;"
            >
              <h4>Download the app now</h4>
              <p>
                Get latest news on DOQMA on your mail and stay connected.
              </p>
              <a class="me-lg-3 mb-4 mb-lg-0" href="https://play.google.com/store/apps/details?id=com.paspatient"
                ><img style="height: 65px;
                width: 187px;"
                  class="app-badge"
                  src="assets/img/google-play-badge.svg"
                  alt="..."
              /></a>
            </div>
            <h1 style="text-align:center;">OR</h1>
            <div
                class=" footer-newsletter"
                style="text-align:center;"
              >
                <h4>Go with web</h4>
                <!-- <p>
                  Get latest news on DOQMA on your mail and stay connected.
                </p> -->
                <button type="button" style="margin-top: 12px;" routerLink class="btn btn-primary btn-lg">Book Appointment</button>
                <!-- <a class="me-lg-3 mb-4 mb-lg-0" href="https://play.google.com/store/apps/details?id=com.paspatient"
                  ><img style="height: 65px;
                  width: 187px;"
                    class="app-badge"
                    src="assets/img/google-play-badge.svg"
                    alt="..."
                /></a> -->
              </div>

          </div>
        </div>
      </div>
      </div>
  
      <div class="container " style="margin-top: 30vw;padding-bottom: 10px;" >
        <div class=" text-center ">
          <div class="copyright">
            &copy; Copyright <strong><span>Mavin Globus</span></strong
            >. All Rights Reserved<br>
            <strong>Email:</strong> mailto:help@doqmatokens.com<br />
          </div>
        </div>
      </div>
    </footer>